import React from "react";
import ReactDOM from "react-dom/client";
import {QueryClient,QueryClientProvider} from "@tanstack/react-query";
import {BrowserRouter} from "react-router-dom";
import "./i18n";
import App from "./App";
import "./styles.css";

const client=new QueryClient({defaultOptions:{queries:{staleTime:10_000,retry:1,refetchOnWindowFocus:false}}});
ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><QueryClientProvider client={client}><BrowserRouter basename="/dating-v1"><App/></BrowserRouter></QueryClientProvider></React.StrictMode>);
